/**
 * Global footer with cookie preferences and privacy policy links.
 * Shown on all pages. Accessible.
 */
import React from 'react'
import { Box, Link, Typography } from '@mui/material'
import { useConsent } from '../contexts/ConsentContext'

const AppFooter = () => {
  const { openPreferences } = useConsent()

  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 2,
        textAlign: 'center',
        fontSize: '0.75rem',
        color: 'text.secondary',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Link
        component="button"
        variant="caption"
        onClick={openPreferences}
        sx={{ cursor: 'pointer', textDecoration: 'underline' }}
        aria-label="Apri preferenze cookie"
      >
        Preferenze cookie
      </Link>
      <Typography component="span" variant="caption" sx={{ mx: 0.5 }}>
        •
      </Typography>
      <Link
        href="/privacy-consent"
        variant="caption"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy policy
      </Link>
    </Box>
  )
}

export default AppFooter
